import isNumber from 'lodash/isNumber'

const generateUnit = (value, options = { unit: 'rem', important: true }) => {
  const { unit = 'rem', important = true } = options
  const result = isNumber(value) ? `${value}${unit}` : value
  return `${result} ${important ? '!important' : ''}`
}

export const createSpacingStyle = ({
  mt,
  mb,
  ml,
  mr,
  mx,
  my,
  margin,
  pt,
  pb,
  pl,
  pr,
  px,
  py,
  padding,
  minWidth,
  minHeight,
}) => ({
  ...mt && ({ marginTop: generateUnit(mt) }),
  ...mb && ({ marginBottom: generateUnit(mb) }),
  ...ml && ({ marginLeft: generateUnit(ml) }),
  ...mr && ({ marginRight: generateUnit(mr) }),
  ...mx && ({ margin: `0 ${generateUnit(mx)}` }),
  ...my && ({ margin: `${generateUnit(my, { important: false })} 0 !important` }),
  ...margin && ({ margin: generateUnit(margin) }),
  ...pt && ({ paddingTop: generateUnit(pt) }),
  ...pb && ({ paddingBottom: generateUnit(pb) }),
  ...pl && ({ paddingLeft: generateUnit(pl) }),
  ...pr && ({ paddingRight: generateUnit(pr) }),
  ...px && ({ padding: `0 ${generateUnit(px)}` }),
  ...py && ({ padding: `${generateUnit(py, { important: false })} 0 !important` }),
  ...padding && ({ padding: generateUnit(padding) }),
  ...minWidth && ({ minWidth }),
  ...minHeight && ({ minHeight }),
})

export const createAlignmentStyle = ({
  display,
  textAlign,
}) => ({
  ...display && { display },
  ...textAlign && { textAlign },
})

export const createFlexStyle = ({
  flex,
  justifyContent,
  alignItems,
  flexDirection,
}) => ({
  ...flex && {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  ...justifyContent && { justifyContent },
  ...alignItems && { alignItems },
  ...flexDirection && { flexDirection },
})



// WEBPACK FOOTER //
// ./src/helpers/styledHelpers.js